export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7137.31509812.jpg";